module.exports = __webpack_public_path__ + "media/38.5731fa34.mp3";